@if (!refreshing) {
  <div id="consultNoteDetailPage">
    <app-consult-note-title [patientAttachment]="patientAttachment" />
    <app-consult-note-header [patientAttachment]="patientAttachment" />
    <app-validate-patient-prescriptions
      [patientAttachment]="patientAttachment"
      />
  </div>
} @else {
  <mat-spinner />
}
